// Wrapper for the Issue Reporting endpoints (staff — uses axiosInstance + staff
// JWT in sessionStorage). All calls hit /api/issues/*.
import axiosInstance from '../../services/axiosInterceptor'

function staffCall(method, path, { params, body, isForm } = {}) {
  const url = `/api/issues${path}`
  const config = { params }
  if (isForm) {
    return axiosInstance[method](url, body, { ...config, headers: { 'Content-Type': 'multipart/form-data' } })
      .then(r => r.data)
  }
  if (method === 'get' || method === 'delete') {
    return axiosInstance[method](url, config).then(r => r.data)
  }
  return axiosInstance[method](url, body, config).then(r => r.data)
}

function call(mode, method, path, opts) {
  return staffCall(method, path, opts)
}

// ─────────── Public to any logged-in user ───────────
export const fetchCategories = (mode = 'staff') =>
  call(mode, 'get', '/categories')

export const fetchDepartments = (mode = 'staff') =>
  call(mode, 'get', '/departments')

export const submitReport = (mode = 'staff', formData) =>
  call(mode, 'post', '/', { body: formData, isForm: true })

export const listMyReports = (mode = 'staff', params = {}) =>
  call(mode, 'get', '/mine', { params })

export const fetchReportDetail = (mode = 'staff', ir_id) =>
  call(mode, 'get', `/${ir_id}`)

export const addComment = (mode = 'staff', ir_id, body) =>
  call(mode, 'post', `/${ir_id}/comments`, { body: { body } })

// ─────────── Staff-only ───────────
export const checkInboxAccess = () =>
  call('staff', 'get', '/inbox/access')

export const listInbox = (params = {}) =>
  call('staff', 'get', '/inbox', { params })

export const changeStatus = (ir_id, status, note) =>
  call('staff', 'patch', `/${ir_id}/status`, { body: { status, note } })

// ─────────── Admin (pos 99) ───────────
export const adminCreateCategory  = (data) => call('staff', 'post',  '/admin/categories', { body: data })
export const adminUpdateCategory  = (id, data) => call('staff', 'put',    `/admin/categories/${id}`, { body: data })
export const adminDeleteCategory  = (id)   => call('staff', 'delete', `/admin/categories/${id}`)
export const adminListDeptHeads   = ()     => call('staff', 'get',    '/admin/department-heads')
export const adminAddDeptHead     = (data) => call('staff', 'post',   '/admin/department-heads', { body: data })
export const adminRemoveDeptHead  = (dh_id) => call('staff', 'delete', `/admin/department-heads/${dh_id}`)
